export const PLAINTEXT_HTML_TRUNCATION_LENGTH = 4000;
export const PLAINTEXT_DESCRIPTION_LENGTH = 2000;
